module.exports = __webpack_public_path__ + "img/process-icon6.72b1a62e.png";